import React from 'react';
import cc from 'classcat';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { Intent } from '@blueprintjs/core';

import Icon from '../../atoms/icon';

export interface HeaderBannerProps {
  intent?: Intent;
  className?: string;
  style?: React.CSSProperties;
  icon?: FontAwesomeIconProps['icon'];
  title: string;
  children?: React.ReactNode;
}

const HeaderBanner: React.FC<HeaderBannerProps> = ({
  intent,
  className,
  style,
  icon,
  title,
  children
}): JSX.Element => {
  const classes = cc([
    'pa-4',
    'text-sans-sm',
    className,
    intent ? `bg-intent-${intent}` : 'bg-light-grey',
    intent && intent !== Intent.NONE ? 'text-white' : null
  ]);
  return (
    <div
      className={classes}
      style={{
        width: '100%',
        ...style
      }}
    >
      {icon ? <Icon title={false} className="mr-4" icon={icon} /> : null}
      <b className="uppercase mr-4">{title}</b>
      {children}
    </div>
  );
};

export default HeaderBanner;
